module.exports = __webpack_public_path__ + "assets/img/img_nexon_point.554e9efa.svg";